export default {
  methods: {
    getDateFormatBasedOnLocale () {
      let locale = this.$store.getters.person.preferences.locale || 'en-US'
      const formats = {
        'zh-CN': 'YYYY/MM/DD',
        'zh-TW': 'YYYY/MM/DD',
        'jp-JP': 'YYYY/MM/DD',
        'ko-KR': 'YYYY/MM/DD',
        'es-CO': 'DD/MM/YYYY',
        'pt-BR': 'DD/MM/YYYY',
        'fr-FR': 'DD/MM/YYYY',
        'de-DE': 'DD/MM/YYYY',
        'en-US': 'MM/DD/YYYY'
      }
      locale = Object.keys(formats).includes(locale) ? locale : 'en-US'
      return formats[locale]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/DateFormatMixin.js